<template>
  <div>
    <template v-for="value in this.menuList">
      <el-submenu
        :index="value.Url"
        v-if="hasChild(value.ID)&&value.IsDropDown=='1'"
        :key="value.ID+''"
      >
        <template slot="title">
          <i :class="value.Icon"></i>
          {{value.Name}}
        </template>
        <my-menu :pID="value.ID"></my-menu>
      </el-submenu>
      <el-menu-item :index="value.Url" v-else :key="value.ID+''">
        <i :class="value.Icon"></i>
        {{value.Name}}
      </el-menu-item>
    </template>
  </div>
</template>
<script>
export default {
  name: "MyMenu",
  props: ["pID"],
  created() {
    this.menuData = this.$store.state.menuData;
    this.rootID = this.pID;
    this.getChild();
  },
  data() {
    return {
      rootID: "0",
      menuData: this.$store.state.menuData,
      menuList: [],
    };
  },

  methods: {
    getChild() {
      let that = this;
      that.menuList = that.menuData.filter(function (m) {
        return m.ParentID == that.rootID;
      });
    },
    hasChild(id) {
      let that = this;
      let tempMenuList = that.menuData.filter(function (m) {
        return m.ParentID == id;
      });
      return tempMenuList.length > 0;
    },
  },
};
</script>
<style lang="less" scoped>
</style>
